import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';
import { CommonLayout_ROUTES } from './shared/routes/common-layout.routes';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { FullLayout_ROUTES } from './shared/routes/full-layout.routes';
import { NoSidenavLayoutComponent } from './layouts/no-sidenav-layout/no-sidenav-layout.component';
import { NoSidenavLayout_ROUTES } from './shared/routes/no-sidenav-layout';
import { NoSidenavNoHeaderLayout_ROUTES } from './shared/routes/no-sidenave-no-header-layout';
import { NoSidenaveNoHeaderLayoutComponent } from './layouts/no-sidenave-no-header-layout/no-sidenave-no-header-layout.component';
import { ContactusComponent } from './modules/contactus/contactus.component';
// import { ErrorHandlingComponent } from './layouts/error-handling/error-handling.component';
import { ErrorHandlingComponent } from './shared/template/error-handling/error-handling.component'

const routes: Routes = [


  // {
  //   path: '',
  //   redirectTo: '/gameDay',
  //   pathMatch: 'full',

  // },
  {
    path: '',
    component: FullLayoutComponent,
    children: FullLayout_ROUTES
  },
  {
    path: '',
    component: CommonLayoutComponent,
    children: CommonLayout_ROUTES
  },


  {
    path: '',
    component: NoSidenavLayoutComponent,
    children: NoSidenavLayout_ROUTES
  },
  {
    path: '',
    component: NoSidenaveNoHeaderLayoutComponent,
    children: NoSidenavNoHeaderLayout_ROUTES
  },
  {
    path: '**',
    component: ErrorHandlingComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
